import { useGet } from "./requestAPI/apiGet"
import { ParentCampaignObject } from "../types/APITypes";

export const useGetParentCampaigns = () => 
    useGet<ParentCampaignObject[]>({
        url: 'parent-campaigns/get-parent-campaigns'
    }); 

    


